import { supabase } from './supabaseClient';
import { validateEmployeeSalary } from './employeeValidation';

export function salaryToday(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
export function validateRevisionDate(date, today = salaryToday()) {
  const parsed = /^\d{4}-\d{2}-\d{2}$/.test(date || '') && new Date(`${date}T00:00:00Z`);
  if (!parsed || !Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return 'Enter a valid effective date.';
  if (date.slice(0, 7) !== today.slice(0, 7) || date > today) return 'Apply salary revisions in the current month, on or after the effective date. Past and future months are not allowed.';
  return '';
}
export function sortSalaryRevisions(hikes = []) {
  return hikes.map((hike, index) => ({ hike, index })).sort((a, b) =>
    String(b.hike.effective_date || b.hike.date || '').localeCompare(String(a.hike.effective_date || a.hike.date || '')) ||
    String(b.hike.created_at || '').localeCompare(String(a.hike.created_at || '')) || b.index - a.index
  ).map(item => item.hike);
}

export async function applySalaryRevisions({ company, actor, changes, effectiveDate = salaryToday(), source, configChanges = {}, client = supabase }) {
  if (!['admin', 'company'].includes(actor?.role)) throw new Error('HR/Admin access is required to revise salary.');
  const dateError = validateRevisionDate(effectiveDate);
  if (dateError) throw new Error(dateError);
  if (!changes?.length) throw new Error('No employees selected for salary revision.');
  const seen = new Set();
  const updates = changes.map(({ employee, patch, note }) => {
    if (!employee?.id || seen.has(employee.id)) throw new Error('Each employee must appear only once in a salary revision.');
    seen.add(employee.id);
    const error = validateEmployeeSalary({ ...employee, ...patch }, company.config || {});
    if (error) throw new Error(`${employee.name || employee.employee_code}: ${error}`);
    return { employee_id: employee.id, expected_salary: Number(employee.basic_salary ?? employee.basic ?? 0), patch, note: note || '' };
  });
  const { data, error } = await client.rpc('apply_salary_revisions', {
    p_company_id: company.id, p_updates: updates, p_effective_date: effectiveDate,
    p_actor: actor.login_username || actor.username || actor.role, p_source: source || 'Salary revision', p_config_patch: configChanges,
  });
  if (error) {
    if (error.code === 'PGRST202' || /could not find.*apply_salary_revisions|does not exist/i.test(error.message || '')) {
      throw new Error('Salary revision database update is required. Run supabase/salary_revisions_update.sql, then retry. No salary changes were saved.');
    }
    throw new Error(error.message || 'Salary revision failed. No changes were saved.');
  }
  if (!data || !Array.isArray(data.employees) || data.employees.length !== changes.length || !data.config) throw new Error('Could not confirm the salary revision result. Refresh employee records before retrying.');
  return data;
}
